import {
  FormInfoBuilder,
  GetPublicJobPositionsOutput,
} from '../form-info.types';

export const getPublicJobPositions = (builder: FormInfoBuilder) =>
  builder.query<GetPublicJobPositionsOutput, void>({
    query: () => ({
      url: '/job-positions/public',
      method: 'GET',
    }),
    providesTags: () => ['JobPositions'],
  });
